import React from 'react';

import { RCTextWithIcon, RCButton } from '@reverbdotcom/cadence/components';
import { AppleIcon } from '@reverbdotcom/cadence/icons/react';

import CsrfForm from '../csrf_form';
import { APPLE_AUTH_PATH } from '../url_helpers';
import { MParticleEventName, trackEvent } from '../elog/mparticle_tracker';
import { titleText, Variant } from './thirdPartyAuth';
import { GOOGLE_RECAPTCHA_TOKEN_PARAM } from '../constants';

interface Props {
  redirectTo: string;
  variant: Variant;
  handleSubmit: (e, input) => void;
}

const formId = 'apple-signup-signin';

export default function AppleSigninButton({ redirectTo, variant, handleSubmit }: Props) {
  const title = titleText({ provider: 'apple', variant });
  const googleRecaptchaTokenInput = React.useRef();
  const onSubmit = (e) => {
    if (handleSubmit) {
      handleSubmit(e, googleRecaptchaTokenInput);
    }
  };

  return (
    <CsrfForm
      id={formId}
      method="post"
      action={APPLE_AUTH_PATH.expand({ origin: redirectTo })}
      onSubmit={(event) => { onSubmit(event); }}
    >
      <RCButton
        isSubmit
        fullWidth
        form={formId}
        variant="secondary"
        onClick={trackAppleSigninButtonClick}
      >
        <RCTextWithIcon
          svgComponent={AppleIcon}
          placement="left"
          size="large"
        >
          {title}
        </RCTextWithIcon>
      </RCButton>
      <input type="hidden" name={GOOGLE_RECAPTCHA_TOKEN_PARAM} ref={googleRecaptchaTokenInput} />
    </CsrfForm>
  );
}

function trackAppleSigninButtonClick() {
  trackEvent({
    componentName: 'AppleSigninButton',
    eventName: MParticleEventName.ClickedAppleSigninButton,
  });
}
